<script setup lang="ts">
import { ChevronRight } from 'lucide-vue-next'

import { ORDER_CHANNEL_SECTIONS } from '../../../lib/brandAppSections'
import useBrandAppConfig from '../../../composables/useBrandAppConfig'

const emit = defineEmits<{
  open: [id: string]
}>()

const { order, updateOrderChannel } = useBrandAppConfig()
</script>

<template>
  <div class="flex flex-col gap-2 px-6">
    <div
      v-for="(section, index) in ORDER_CHANNEL_SECTIONS"
      :key="section.id"
      class="border-border hover:border-foreground-disabled motion-safe:animate-card-in relative flex items-center gap-3 rounded-xl border p-3 transition-colors"
      :class="order.channels[section.channel].enabled ? 'bg-background shadow-surface' : 'bg-muted/50'"
      :style="{ animationDelay: `${Math.min(index, 5) * 40}ms` }"
    >
      <Button
        variant="ghost"
        class="h-auto min-w-0 flex-1 justify-start gap-3 p-0 text-left after:absolute after:inset-0 after:rounded-xl hover:bg-transparent dark:hover:bg-transparent"
        @click="emit('open', section.id)"
      >
        <span
          class="flex size-10 shrink-0 items-center justify-center rounded-xl"
          :class="order.channels[section.channel].enabled ? 'bg-muted' : 'bg-background'"
        >
          <component
            :is="section.icon"
            class="size-4.5"
            :class="order.channels[section.channel].enabled ? 'text-primary' : 'text-foreground-disabled'"
          />
        </span>
        <span
          class="min-w-0 truncate text-sm font-medium"
          :class="order.channels[section.channel].enabled ? 'text-foreground' : 'text-foreground-secondary'"
        >
          {{ section.name }}
        </span>
      </Button>
      <Switch
        :id="`brandApp.order.${section.channel}.enabled`"
        class="relative z-10"
        :aria-label="section.name"
        :model-value="order.channels[section.channel].enabled"
        @update:model-value="updateOrderChannel(section.channel, 'enabled', $event)"
      />
      <ChevronRight class="text-foreground-disabled size-4 shrink-0" />
    </div>
  </div>
</template>
